module.exports = __webpack_public_path__ + "static/media/3.5.0c17bef8.png";